import { AVATAR_IDS, NICKNAME_MAX, type AvatarId } from '@gmp/shared-types/browser';
import { Avatar } from '@gmp/shared-ui';
import { sound } from '../app/prefs';

/** Nickname + avatar picker used by create, join and settings. */
export function ProfileFields({ nickname, avatar, onNickname, onAvatar }: { nickname: string; avatar: AvatarId; onNickname: (v: string) => void; onAvatar: (a: AvatarId) => void }) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-4">
        <Avatar id={avatar} size={76} className="shrink-0 animate-pop" key={avatar} />
        <label className="flex-1 flex flex-col gap-1">
          <span className="text-sm font-bold text-mute">Your nickname</span>
          <input
            className="field font-display font-bold text-xl"
            value={nickname}
            maxLength={NICKNAME_MAX}
            autoComplete="nickname"
            enterKeyHint="go"
            placeholder="e.g. Captain Chaos"
            onChange={(e) => onNickname(e.target.value)}
            data-testid="nickname-input"
          />
        </label>
      </div>
      <div>
        <span className="text-sm font-bold text-mute">Pick your character</span>
        <div className="grid grid-cols-8 gap-1.5 mt-2" role="radiogroup" aria-label="Avatar">
          {AVATAR_IDS.map((id) => (
            <button
              key={id}
              role="radio"
              aria-checked={avatar === id}
              aria-label={id}
              onClick={() => { onAvatar(id); sound.play('tap'); }}
              className={`rounded-xl p-0.5 transition ${avatar === id ? 'bg-[var(--accent)] scale-110' : 'bg-ink-3 hover:bg-line'}`}
            >
              <Avatar id={id} size={36} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
